{ getSeparatorClassName } = require 'app/scripts/views/card/SeparatorCard/SeparatorCard'
pluginsChangedSignal = require 'app/scripts/views/internal/plugins/plugins-changed-signal'
{ sendPluginUIEvent } = require('app/scripts/lib/plugins/plugin-behavioral-analytics')
t = require('app/scripts/views/internal/teacup-with-helpers')('card_aging')
View = require 'app/scripts/views/internal/view'

CARD_AGING_POWER_UP_ID = require('app/scripts/data/legacy-power-ups').cardAging

template = t.renderable ({ evergreen }) ->
  t.ul '.pop-over-list', ->
    t.li ->
      t.a '.js-toggle-ignore', { href: '#' }, ->
        t.span '.name', ->
          t.format 'evergreen'
          if evergreen
            t.icon 'check'
        t.span '.sub-name', ->
          t.format 'evergreen cards'

module.exports = class CardAgingPopoverView extends View
  viewTitleKey: 'card aging'

  initialize: ->
    @getEvergreenData()
    @subscribe pluginsChangedSignal(@model.getBoard(), @model), =>
      @render()

  events:
    'click .js-toggle-ignore': 'toggleIgnore'

  getEvergreenData: ->
    @evergreen = @model.getPluginDataByKey(
      CARD_AGING_POWER_UP_ID,
      'card',
      'shared',
      'evergreen',
      false
    )

  toggleIgnore: ->
    @model.setPluginDataByKey(
      CARD_AGING_POWER_UP_ID,
      'card'
      'shared',
      'evergreen',
      !@evergreen
    )
    sendPluginUIEvent({
      idPlugin: CARD_AGING_POWER_UP_ID
      idBoard: @model.getBoard().id
      idCard: @model.id
      event:
        action: 'clicked'
        actionSubject: 'button'
        actionSubjectId: 'cardAgingEvergreenButton'
        attributes:
          isEvergreenAfterClick: @evergreen
          isTemplate: @model.get('isTemplate')
          separatorType: getSeparatorClassName(@model.get('name'))
        source: 'cardDetailScreen'
    })
    @render()

  render: ->
    @getEvergreenData()
    @$el.html template ({ evergreen: @evergreen })
    @